export default {
    methods: {
        async $postCommand(command, data, customOptions) {
            const options = customOptions || {
                showProgress: true
            };

            if (options.showProgress) {
                this.$startLoading();
            }
            try {
                const params = {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                };
                const token = this.$authToken();
                if (token) {
                    params.headers.Authorization = token;
                }
                const resp = await this.$http.post(`/api/web/command/${command}`, data || {}, params);
                return resp.data;
            } finally {
                if (options.showProgress) {
                    this.$finishLoading();
                }
            }
        },
        async $post(command, data, customOptions) {
            const options = customOptions || {
                showProgress: true
            };

            if (options.showProgress) {
                this.$startLoading();
            }
            try {
                const params = {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                };
                const resp = await this.$http.post(`/api/investor/${command}`, data || {}, params);
                return resp.data;
            } finally {
                if (options.showProgress) {
                    this.$finishLoading();
                }
            }
        },
        async $get(path, customOptions) {
            const options = customOptions || {
                showProgress: true
            };

            if (options.showProgress) {
                this.$startLoading();
            }
            try {
                const params = {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                };
                const resp = await this.$http.get(`/api/investor/${path}`, params);
                return resp.data;
            } finally {
                if (options.showProgress) {
                    this.$finishLoading();
                }
            }
        },

        // in case this method is called $delete warning appears in console:
        // vue.runtime.esm.js?2b0e:619 [Vue warn]: Method "$delete" conflicts with an existing Vue instance method.
        // Avoid defining component methods that start with _ or $.
        async httpDelete(path, customOptions) {
            const options = customOptions || {
                showProgress: true
            };

            if (options.showProgress) {
                this.$startLoading();
            }
            try {
                const resp = await this.$http.delete(`/api/investor/${path}`);
                return resp.data;
            } finally {
                if (options.showProgress) {
                    this.$finishLoading();
                }
            }
        },
        async $fetchInvestorProfile() {
            const profile = await this.$http.get('/api/investor/profile')
            this.$root.$data.investorProfile = profile.data;
            return profile;
        },
        $resolveInvestorRoutes() {
            const profile = this.$root.$data.investorProfile

            const allowedRoutesAfterRegistration = [
                'dashboard', //NEEDS TO BE FIRST
                'account-statement',
                'autoinvestment',
                'autoinvestment-strategy',
                'bank-account',
                'borrower',
                'borrowers',
                'complete-email-verification',
                'document-verification',
                'veriff',
                'documents',
                'investment',
                'personal-details',
                'phone-verification',
                'accept-terms',
                'portfolio',
                'profile-personal-details',
                'profile-phone-verification',
                'questionnaire',
                'settings',
                'status-verification',
                'status-verification-rejected',
                'tranche-invest',
                'tranche-invest-prev',
                'tranche-listing',
                'tranche-listing-prev',
                'wallet'
            ];

            if (profile.investorStatus === 'REJECTED') {
                return ['rejected'];
            }
            if (profile.registrationStep === 'COMPLETED') {
                return allowedRoutesAfterRegistration;
            }

            if (profile.registrationStep === 'EMAIL_VERIFICATION') {
                return ['email-verification'];
            } else {
                return allowedRoutesAfterRegistration;
            }
        },
        async $routeInvestor() {
            const routes = this.$resolveInvestorRoutes();
            const path = routes[0];
            await this.$router.push('/' + path);
        },
        $storeLogin(token) {
            localStorage.setItem('web_token', token);
        },
        async $login(token) {
            this.$storeLogin(token);
            await this.$fetchInvestorProfile();
             const authCookie = this.$authToken();
             if (this.$root.$data.investorProfile.vwoFeatures.redirectApp.appToRedirect === 'react') {
                await this.$redirectToReact('react' ,authCookie );
              }else{
               await this.$routeInvestor();
              }
            this.$identify(this.$root.$data.investorProfile);
            this.$trackEvent('Investor: logged in');

        },
        $cleanLogin() {
            this.$http.post('/api/investor/logout');
            localStorage.removeItem('web_token');
        },
        $authToken() {
            return localStorage.getItem('web_token');
        },
        $startLoading() {
            this.$root.$data.loadingProgress++;
        },
        $finishLoading() {
            this.$root.$data.loadingProgress--;
        },

        $redirectToReact(appToRedirect, authCookie) {

            const originalCookies = document.cookie;
            console.log('original cookies');
            console.log(originalCookies);
            const parsedCookies = this.$parseCookies(originalCookies);
              const userProfile = this.$fetchInvestorProfile();
            // Set cookies for the common root domain
            this.$setCookies(parsedCookies, ".kilde.sg",authCookie,userProfile);
            // Redirect to the new subdomain
            if (appToRedirect === "react") {
               if (!this.$isProd) {
                 window.location.href = 'https://staging.kilde.sg/dashboard';
                } else {
                 window.location.href = 'https://app.kilde.sg/dashboard';
                }
            }
        },
        $parseCookies(cookiesString) {
            const cookies1 = cookiesString.split("; ").reduce((acc, cookie) => {
                let parts = cookie.split("=");
                acc[parts[0]] = parts[1];
                return acc;
              }, {});
              return cookies1;
        },
        $setCookies(cookiesObject, domain, authCookie ,profile) {
            for (var cookieName in cookiesObject) {
              if (cookiesObject.hasOwnProperty(cookieName)) {
                document.cookie =
                  cookieName +
                  "=" +
                  cookiesObject[cookieName] +
                  "; domain=" +
                  domain +
                  "; path=/";
              }
            }

            document.cookie =

                  "auth_inv_token=" + authCookie
                   +
                  "; domain=" +
                  domain +
                  "; path=/";
                     document.cookie =

                   "user=" + JSON.stringify(profile)
                    +
                    "; domain=" +
                    domain +
                    "; path=/";
        },
       async $goBackToNewPlatform() {
               try {
               await this.$post('save/prefredApp?prefredUserApp=react')
               } catch (error) {
               console.log('API call failed!');
              } finally {
              console.log('Just before calling authtoken');
              const authCookie = this.$authToken();
              this.$redirectToReact('react', authCookie);
          }
         }
    }
}
